import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import { ContentWrapper } from '@eti/components';
import { css, mediaQueries } from '@eti/styles';
import { ancillaryBundle, ProductBundle } from '@eti/products';
import { Option, TravelerNew } from '@eti/types';
import { YOUR_SELECTED_TRIP } from '../../../constants/formNamesConstants';
import { sortOptions } from '../../../utils/transformBundleData';
import EtgFares from './etg-fares/EtgFares';

const wrapperStyles = css`
  margin-bottom: 24px;
  margin-top: 10px;

  @media ${mediaQueries.medium.up} {
    margin-top: 24px;
  }
`;

const ancillaryBundleStyles = css`
  background-color: #fff;
`;

const AncillaryBundleSelection = ({
  ancillaryBundleId,
  discountPercentage,
  form,
  handleProceedButtonClick,
  onSkipStepClick,
  numberOfTravelers,
  options,
  selectedBundleId,
  setSelectedBundleOption,
  shouldDisplayEtgFares,
  travelers,
}) => {
  return shouldDisplayEtgFares ? (
    <EtgFares
      discountPercentage={discountPercentage}
      handleProceedButtonClick={handleProceedButtonClick}
      name={ancillaryBundle.name}
      numberOfTravelers={numberOfTravelers}
      onChange={setSelectedBundleOption}
      onSkipStepClick={onSkipStepClick}
      options={sortOptions(options)}
      selectedBundleId={selectedBundleId}
    />
  ) : (
    <ContentWrapper className={wrapperStyles}>
      <ProductBundle
        ancillaryBundleId={ancillaryBundleId}
        className={ancillaryBundleStyles}
        discountPercentage={discountPercentage}
        form={form}
        options={options}
        shouldShowConfirmationButton={false}
        travelers={travelers}
      />
    </ContentWrapper>
  );
};

AncillaryBundleSelection.propTypes = {
  ancillaryBundleId: PropTypes.string,
  discountPercentage: PropTypes.number,
  form: PropTypes.string,
  handleProceedButtonClick: PropTypes.func,
  numberOfTravelers: PropTypes.number,
  onSkipStepClick: PropTypes.func,
  options: PropTypes.arrayOf(Option),
  selectedBundleId: PropTypes.string,
  setSelectedBundleOption: PropTypes.func,
  shouldDisplayEtgFares: PropTypes.bool,
  travelers: PropTypes.arrayOf(TravelerNew),
};

const withReduxForm = reduxForm({
  form: YOUR_SELECTED_TRIP,
  enableReinitialize: true,
});

export default withReduxForm(AncillaryBundleSelection);
